export enum ModeTypes {
    LIGHT = 'light',
    DARK = 'dark'
}
